import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { workflowStatusService } from '../../services/workflow-status.service'
import { WorkflowStatus } from '../../types'
import { ColorInput, EditDialog, FormField, TextInput } from '../common/EditDialog'

interface WorkflowStatusEditDialogProps {
  object?: WorkflowStatus | null
  isCreating: boolean
  onSuccess: () => void
  onError: (error: any) => void
  onClose: () => void
}

const DEFAULT_COLOR = '#6c757d'

export const WorkflowStatusEditDialog: React.FC<WorkflowStatusEditDialogProps> = ({
  object,
  isCreating,
  onSuccess,
  onError,
  onClose,
}) => {
  const { t } = useTranslation()
  const [formData, setFormData] = useState<Partial<WorkflowStatus>>({})

  useEffect(() => {
    if (object) {
      setFormData({
        ...object,
      })
    } else {
      setFormData({
        name: '',
        color: DEFAULT_COLOR,
      })
    }
  }, [object])

  const handleInputChange = (field: string, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const validateForm = (data: Partial<WorkflowStatus>): string[] => {
    const errors: string[] = []
    if (!data.name || data.name.trim() === '') {
      errors.push('name:Name is required')
    }
    if (!data.color || data.color.trim() === '') {
      errors.push('color:Color is required')
    }
    return errors
  }

  const getFormFields = (errors?: Record<string, string>) => {
    return (
      <>
        <FormField label={t('name')} required error={errors?.name}>
          <TextInput
            value={formData.name || ''}
            onChange={(value) => handleInputChange('name', value)}
            placeholder={t('enter_name')}
            required
            autoComplete="off"
            error={errors?.name}
          />
        </FormField>

        <FormField label={t('color')} required error={errors?.color}>
          <ColorInput
            value={formData.color || DEFAULT_COLOR}
            onChange={(value) => handleInputChange('color', value)}
            error={errors?.color}
          />
        </FormField>
      </>
    )
  }

  const getTitle = () => {
    return isCreating ? t('document_workflow.statuses.create_new') : t('document_workflow.statuses.edit')
  }

  return (
    <EditDialog
      object={object}
      isCreating={isCreating}
      onSuccess={onSuccess}
      onError={onError}
      onClose={onClose}
      service={workflowStatusService}
      formData={formData}
      getFormFields={getFormFields}
      getTitle={getTitle}
      validateForm={validateForm}
    />
  )
}
